import { TAB_TYPE } from '@/types/pages/storeManagement/registration/registrationTypes';
import { RegisterStepConfig } from './type';

export const REGISTER_STEPS: RegisterStepConfig[] = [
    {
        key: TAB_TYPE.AP,
        label: TAB_TYPE.AP,
        actionLabel: `Add ${TAB_TYPE.AP}`,
    },
    {
        key: TAB_TYPE.RT,
        label: TAB_TYPE.RT,
        actionLabel: `Add ${TAB_TYPE.RT}`,
    },
    {
        key: TAB_TYPE.TAG,
        label: TAB_TYPE.TAG,
        actionLabel: `Add ${TAB_TYPE.TAG}`,
    },
];

export const REGISTER_DEVICE_FOOTER_HEIGHT = 120;
